import React, { useContext } from "react";
import { MenuContext } from "../../context";
import ExternalLink from "../external-link/external-link.component";
import ContactSvg from "../../assets/contact.inline.svg";
import NewWindow from "../../assets/new_window.inline.svg";
import PhoneSvg from "../../assets/phone.inline.svg";
import GeneralAnchor from "../general-anchor/general-anchor.component";

const LiveChat = ({ onClick }) => {
  const menuContext = useContext(MenuContext);

  return (
    <section className="live-chat">
      <ExternalLink
        to="https://www.hsbc.co.uk/mortgages/intermediaries/help/"
        target="_blank"
        className="general-anchor-btn live-chat-btn"
        onClick={() => onClick("Chat with us")}
      >
        Chat with us
        <NewWindow />
      </ExternalLink>
      <div className="description">
        <ContactSvg />
        <p>
          Our Chat facility gives you quick access to a member of our experienced UK based Broker Support Team who will
          be happy to provide assistance with all your queries.
        </p>
      </div>
      <div className="row">
        <div className="contact-us col-xs-12 col-md-12 col-xl-6">
          <h3>Please contact us on</h3>
          <address>
            <a
              href="tel:03456005847"
              inert={menuContext.isMenuOpen ? "true" : null}
              onClick={() => onClick("03456005847")}
            >
              0345 600 5847
            </a>
          </address>
          <p className="date">
            Monday - Friday, <time datatype="9:00">9am</time> - <time dateTime="17:00">5pm</time>
          </p>
          <ul>
            <li>
              <p>
                <PhoneSvg />
                <strong>Press 1</strong> if you are a customer calling to pay a fee
              </p>
            </li>
            <li>
              <p>
                <PhoneSvg />
                <strong>Press 2</strong> for policy and criteria questions
              </p>
            </li>
            <li>
              <p>
                <PhoneSvg />
                <strong>Press 3</strong> for assistance with keying a new application
              </p>
            </li>
            <li>
              <p>
                <PhoneSvg />
                <strong>Press 4</strong> for case updates or queries relating to valuations / solicitors, or to <strong style={{ color: "#000", fontFamily: "Uni_Next_HSBC_Medium, Arial, sans-serif" }}>amend</strong> customer / solicitor or direct debit details

              </p>
            </li>
            <li>
              <p>
                <PhoneSvg />
                <strong>Press 5</strong> to contact our High Value Mortgage Service for applications over £1m
              </p>
            </li>
          </ul>
          <p>
            <strong style={{ color: "#000", fontFamily: "Uni_Next_HSBC_Medium, Arial, sans-serif" }}>To amend an application, please see below guidance on how to request the required change.
            </strong>
          </p>
        </div>
        <div className="solicitor-section col-xs-12 col-md-12 col-xl-6">
          <div className="solicitor-panel">
            <h3>Solicitor panel checker</h3>
            <p>
              Check if your chosen Solicitor / Conveyancer is on our panel and can act on the case without incurring
              additional costs.
            </p>
            <GeneralAnchor isBlank href="/solicitor-panel-checker" rel="noreferrer" isLink={true} isRed={true}>
              Check solicitor
            </GeneralAnchor>
          </div>
          <h3>Solicitors / Conveyancers only</h3>
          <p>
            If you are a Solicitor / Conveyancer and have a query, please visit LMS Secure Link in the first instance to review the guidance. If your query relates to imminent completion or exchange, you can call our Help Desk on  <strong class="phoneNumber">
              <a href="tel:03706007722">0370 6007722</a>
            </strong>, or chat with us via our  <a className="inline-link" href="https://www.hsbc.co.uk/mortgages/conveyancers-help/" target="_blank">
              Conveyancer Helpdesk
            </a>.

          </p>
          <p>
            Please note that we will only be able to verify Solicitor / Conveyancer telephone calls to this number following a written request or a request via LMS Secure Link. Please refer to the criteria section{" "}
            <a
              title="Solicitors/Conveyancers only"
              href="/criteria/?p=solicitors-conveyancers-only"
              onClick={() => onClick("Solicitors/Conveyancers only")}
              className="inline-link"
            >
              Solicitors / Conveyancers only
            </a>{" "}
            for more information.
          </p>
          <p>
            <strong>We are not able to deal with any broker enquiries via this telephone number.</strong>
          </p>
        </div>
      </div>
    </section >
  );
};

export default LiveChat;
